<template>
  <div class="cartApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="cart">
      <ul>
        <li v-for="(item,i) in pro">
          <div class="delete">
            <div class="input_check">
              <span class="ico_gou" :class="{'ico_gou_on':item.checked}" @click="selectGoods(item)"></span>
            </div>
          </div>
          <el-image class="img" :src="baseUrl+item.coverChart" fit="fill">
            <div slot="placeholder" class="image-slot">
              <span class="dot"><i class="el-icon-loading"></i></span>
            </div>
          </el-image>
          <div class="names">
            <div class="bt">{{item.proName}}</div>
            <div class="jg">
              <span>￥{{item.price}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div style="height:60px"></div>

    <div class="cartFooter">
      <div class="foot-title">
        <span>{{sum}}件商品</span>
        <span>已选择</span>
      </div>
      <div class="pay" @click="toDo()">
        <span>确认选择</span>        
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        pro:[],
        baseUrl:'',
        sum:0,
        userData:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getProduct()
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getProduct:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'wx/product/index'
        }).then(function(response){
          var res = response.data;
          that.pro = res.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      // (单选)选择商品
      selectGoods(item){
        //判断是否未定义，如果没点击过按钮是没有注册的，则需要先注册checked属性
        if(typeof item.checked =='undefined'){
          this.$set(item,"checked",true);
          this.sum ++;  //结算需要显示的数量
        }else{
          //  如果已经注册，则设置checked否(这里不能设置为false,因为当已经注册过之后再点击为flase，那么再点击一次则为true)
          item.checked = !item.checked;
          item.checked ? this.sum ++ : this.sum --;
        }
      },
      toDo(){
        if(this.sum <= 0){
          this.$alert('请先选择产品！', '警告', {
            confirmButtonText: '确定',
            showClose:false,
            callback: action => {
            }
          });
          return false;
        }
        else{
          // 结算选中的商品
          var isList = [];
          for(var i in this.pro){
            if(this.pro[i].checked){
              isList.push(this.pro[i].id);
            }
          }
          var that = this;
          var model = JSON.stringify(isList);
          console.log(model);
          this.axios({
            method:'post',
            url:that.$host+'wx/news/choose',
            params:{
              userId:that.userData.id,
              proId:model
            }
          }).then(function(response){

            that.$router.back()
          }).catch(err=>{
            console.log('请求失败:'+err);
          });
        }
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .cartApp{
    max-width:640px;
    background:#ededed;
    margin:0 auto;
  }
  .cartApp .cart{
    width:94%;
    display:block;
    margin:0 auto;
  }
  .cartApp .cart ul{
    padding-top:10px;
  }
  .cartApp .cart li{
    background:#fff;
    border-radius:6px;
    padding:10px 0;
    margin-bottom:10px;
    position:relative;
  }
  .cartApp .cart li:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  } 
  .cartApp .cart li .img{
    float:left;
    width:30%;
    height:90px;
    border-radius:6px;
    margin-left:15%
  }

  .cartApp .cart li .names{
    float:left;
    margin-left:10px;
    width:50%;
    height:90px;
    position:relative;
  }
  .cartApp .cart li .names .bt{
    font-size: 14px;
    color: #000;
    font-weight:bold;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2; 
    width:86%;
    margin-top:-2px
  }
  .cartApp .cart li .names .jg{
    position:absolute;
    bottom:2px;
    width:100%;
  }
  .cartApp .cart li .names .jg span{
    font-size:14px;
    font-weight:bold;
    color:#ed0014;
    position:relative;
    top:2px;
  }
  .cartApp .cart li .names .jg .num{
    float:right;
    border:#ededed solid 1px;
    border-radius:40px;
    padding:0px 0px
  }
  .cartApp .cart li .names .jg .num font{
    background:#ededed;
    font-size:14px;
    padding:3px 10px;
    float:left
  }
  .cartApp .cart li .names .jg .num i{
    padding:3px 10px;
    font-size:14px;
    font-size:#333;
    float:left;
    margin-top:3px
  }
  .cartApp .cart li .delete{
    position:absolute;
    left:12px;
    top:50%;
    transform: translateY(-100%);
  }

  .cartApp .none{
    text-align:center;
    padding-top:50%;
    display:none;
  }
  .cartApp .none img{
    width:120px;
  }
  .cartApp .none p{
    color:#cdcdcd;
    font-size:14px;
  }


  .cartApp .cartFooter{
    height: 50px;
    background: #fff;
    width: 100%;
    box-shadow:0px 0px 20px 0px rgba(102,102,102,0.3);
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999
  }
 .cartApp .cartFooter .foot-title{
    float: left;
    margin-left: 4%;
    margin-top: 8px;
  }
  .cartApp .cartFooter .foot-title span{
    display: block;
    font-size: 12px;
    color: #727272;
    text-align:center;
  }
  .cartApp .cartFooter .foot-title span:last-child{
    font-size: 16px;
    color: #000;
    position: relative;
    left: -4rpx;
    font-weight: bold
  }
  .cartApp .cartFooter .gou{
    float:left;
    text-align:center;
    margin-left:22px;
    margin-top:5px;
    position:relative;
  }
  .cartApp .cartFooter .gou img{
    display:block;
    width:20px;
    border:0;
    position:relative;
    top:3px;
    margin:0 auto;
  }
  .cartApp .cartFooter .gou span{
    font-size:12px;
  }
  .cartApp .cartFooter .gou font{
    position:absolute;
    right:0;
    top:-3px;
    border-radius:50%;
    background:#fa0024;
    color:#fff;
    font-size:12px;
    width:15px;
    height:15px;
    text-align:center;
    line-height:15px;
  }
  .cartApp .cartFooter .pay{
    float: right;
    color: #fff;
    margin-right: 2%;
    margin-top:5px;
    width:60%
  }
  .cartApp .cartFooter .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #fa0024;
    border-radius:40px
  }


  .input_check{
    position: relative;
    width:20px;
    height:20px;
  }
  .input_check span{
    display: block;
    position: absolute;
    top:4px;
    left:4px;
    width:20px;
    height:20px;
    border-radius:50%;
    border:solid 1px #ccc;
    background-size:100%
  }
  .ico_gou_on{
    background-image: url(./../../assets/images/ico_gou_on.png);
  }

</style>